<template>
  <div id="QuoteNew">
    <b-container fluid class="px-lg-5 py-lg-5 pt-5 font-interface">
      <div class="bg-white p-3 rounded mb-5 shadow-sm" v-if="this.formValues.Title">
        <h4 class="p-0 m-0  font-weight-bold">
         {{this.contextText.type}} - {{ this.formValues.Title }}
        </h4>
      </div>
      <FormulateForm
        :invalid-message="invalidMessage"
        v-model="formValues"
        @submit="submitHandler"
        #default="{ hasErrors }"
      >
        <div class="row pb-5">
          <div class="col-md-4 order-md-2 mb-4">
            <div class="bg-white p-3 rounded shadow-sm">
              <div class="sticky-top">
                <h4
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                    
                  "
                >
                  <span class="font-weight-bold">Quote Details</span>
                  <b-spinner
                    v-if="loading"
                    variant="info"
                    label="Spinning"
                  ></b-spinner>
                </h4>
                <hr>
                <ul class="list-group mb-3 text-left">
                  <li class="d-none d-lg-block list-group-item py-3">
                    <h6 class="my-0 pb-2">Quote Settings</h6>
                    <div class="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="form-check-input mt-0"
                        v-model="settingCalculateTotals"
                        name="settingCalculateTotals"
                        value="false"
                      />
                      <label
                        class="form-check-label small d-flex align-self-center"
                        for="settingCalculateTotals"
                        >Auto Calculate Totals?</label
                      >
                      <div
                        class="d-flex align-self-center"
                        v-b-tooltip.hover
                        placement="auto"
                        title="Tip: Turn this setting on to ensure you're entering the pricing correctly, and then switch off when you want to do final tweaks to the totals."
                      >
                        <b-icon
                          class="ml-1"
                          icon="question-circle"
                          variant="secondary"
                        ></b-icon>
                      </div>
                    </div>
                  </li>
                  <li class="d-none d-lg-block list-group-item py-3">
                    <FormulateInput
                      type="select"
                      v-model="Status"
                      name="Status"
                      label="Status"
                      validation="required"
                      input-class="form-control"
                      placeholder="Required"
                      :options="StatusOptions"
                    />
                  </li>
                  <li
                    class="
                      list-group-item
                      d-flex
                      justify-content-between
                      lh-condensed
                    "
                  >
                    <div>
                      <h6 class="my-0 pb-2">Client Details</h6>
                      <small class="text-muted"
                        >Contact Person: {{ clientName }}</small
                      ><br />
                      <small class="text-muted">Email: {{ clientEmail }}</small
                      ><br />
                      <small class="text-muted">Phone: {{ clientPhone }}</small>
                    </div>
                  </li>

                  <li class="list-group-item d-flex justify-content-between">
                    <span>Total (Exc GST) </span>
                    <strong>${{ formValues.Total }}</strong>
                  </li>
                  <li class="d-none d-lg-block list-group-item py-3">
                    <FormulateInput
                      type="submit"
                      input-class="btn btn-primary btn-lg btn-block bg-gradient"
                      :label="contextText.action + ' Quote'"
                    />
                  </li>
                  <li class="d-none d-lg-block list-group-item py-3" v-if="hasErrors">
                      <h5 v-if="invalidFields"><strong>Invalid Fields:</strong></h5>
                      <div v-if="invalidFields">
                        <div :key="index" v-for="(item, index) in invalidFields">
                          <div class="pb-1" style="color:#CE2727;font-size: 12px; font-weight: bold;">{{item}}</div>
                        </div>
                      </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-8 order-md-1 text-left">
            <div class="bg-white p-3 rounded shadow-sm">
              <h4 class="mb-3  font-weight-bold">{{ contextText.type }} Quote</h4>
              <hr>
              <div class="mb-3">
                <FormulateInput
                  type="text"
                  name="QuoteNumber"
                  label="Quote Number"
                  help="Enter a unique quote number."
                  validation="required"
                  validation-name="Quote Number"
                  input-class="form-control"
                  placeholder="Required"
                />
              </div>
              <div class="mb-3">
                <FormulateInput
                  type="text"
                  name="Title"
                  label="Quote Title"
                  validation-name="Quote Title"
                  validation="required"
                  input-class="form-control"
                  placeholder="Required"
                />
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <FormulateInput
                    type="date"
                    name="Date"
                    label="Date"
                    placeholder="Required"
                    validation="required"
                    input-class="form-control"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <FormulateInput
                    type="date"
                    name="Expiry"
                    label="Expiry Date"
                    validation-name="Expiry Date"
                    placeholder="Required"
                    validation="required"
                    input-class="form-control"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6 mb-3">
                  <FormulateInput
                    type="autocomplete"
                    v-model="ClientAutocomplete"
                    :validation-messages="{
                      myValidateClient: myValidateClientMessage,
                    }"
                    name="ClientAutocomplete"
                    validation="|myValidateClient:client"
                    :validation-rules="{ myValidateClient }"
                    input-class="form-control"
                    placeholder="Required"
                    label="Select Client"
                    :options="ClientOptions"
                  />

                  <FormulateInput
                    type="hidden"
                    v-model="client"
                    name="Client"
                    validation="required"
                    input-class="form-control"
                    placeholder="Required"
                  />
                </div>

                <div class="col-6 mb-3 d-flex align-items-end">
                  <div class="d-flex align-items-center">
                    <b-button class="bg-gradient"
                      id="show-btn"
                      v-if="formValues.Client == ''"
                      @click="$bvModal.show('bv-modal-createClient')"
                      >Create Client</b-button
                    >
                    <div
                      class=""
                      v-b-tooltip.hover
                      placement="auto"
                      v-if="formValues.Client == ''"
                      title="If your client doesn't appear in the dropdown when typing, create the client."
                    >
                      <b-icon
                        class="ml-1 h5 m-0 d-flex align-self-center"
                        icon="question-circle"
                        variant="secondary"
                      ></b-icon>
                    </div>
                  </div>
                </div>

                <div class="col-12 mb-3 staff-members--block">
                  <FormulateInput
                    v-model="webmadstaffs"
                    :options="StaffmemberOptions"
                    type="checkbox"
                    placeholder="Required"
                    label="Staff Members"
                    :validation-messages="{
                      required: 'Staff Members are required',
                    }"
                    name="webmadstaffs"
                    validation="required"
                    element-class="d-flex justify-content-start"
                    input-class="pr-3"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <FormulateInput
                    type="textarea"
                    name="Summary"
                    v-model="Summary"
                    label="Project Outline"
                    validation-name="Project Outline"
                    placeholder="Required"
                    validation="required"
                    input-class="form-control editor"
                  />
                </div>
              </div>
            </div>
            <div class="bg-white p-3 rounded shadow-sm mt-5">
            <div class="row">
              <div class="col">
                <h4 class="pt-2 font-weight-bold mb-4">
                  Quote Items
                  <b-button
                    variant="outline-secondary"
                    v-b-toggle.collapse-quoteItems
                    class="btn-sm float-right"
                    ><span class="when-open">Hide All</span
                    ><span class="when-closed">Show All</span></b-button
                  >
                </h4>

                <b-collapse visible id="collapse-quoteItems">
                  <FormulateInput
                    type="group"
                    #default="{ index }"
                    name="QuoteItem"
                    v-model="QuoteItem"
                    :repeatable="true"
                    add-label="Add Quote Item"
                    validation="required"
                    remove-position="after"
                    label="Quote Items"
                  >
                    
                    <div class="pb-3" v-b-toggle="'collapse-quoteItem-' + index + '-trigger'" v-if="formValues.QuoteItem[index]">
                        <div class="font-weight-bold d-inline-block" v-if="formValues.QuoteItem[index].Item && formValues.QuoteItem[index].Heading" v-html="formValues.QuoteItem[index].Item + ' - <small>' + formValues.QuoteItem[index].Heading +'</small>'" ></div>
                        <div class="font-weight-bold d-inline-block" v-else>New Quote Item</div>
                        <b-icon font-scale="2" class="when-closed float-right" icon="arrows-angle-expand" variant="dark"></b-icon>
                        <b-icon font-scale="2" class="when-open float-right" icon="arrows-collapse" variant="dark"></b-icon>
                    </div>                  
                    <b-collapse :id="'collapse-quoteItem-' + index + '-trigger'">
                    <div class="row quote-item">
                      <div class="col-12 mt-3 pt-2">
                        <FormulateInput
                          name="Item"
                          validation="required"
                          placeholder="Required"
                          label="Quote Item Name"
                          validation-name="Quote Item Name"
                          input-class="form-control"
                        />
                      </div>

                      <div class="col-12 mt-3 pt-2">
                        <FormulateInput
                          type="autocomplete"
                          @input="setQuoteItemTotal(index)"
                          name="Heading"
                          @blur-context="updateQuoteHeadings"
                          validation="required"
                          input-class="form-control"
                          placeholder="Required"
                          label="Heading"
                          :options="HeadingOptions"
                        />
                      </div>
                      <div class="col-12 pt-3">
                        <FormulateInput
                          type="textarea"
                          name="Description"
                          label="Description"
                          placeholder="Required"
                          validation="required"
                          input-class="form-control editor"
                        />
                      </div>
                      <div class="col-4 pt-3"  v-if="settingCalculateTotals">
                        <FormulateInput
                         
                          type="number"
                          @input="setQuoteItemTotal(index)"
                          name="Quantity"
                          label="Quantity"
                          placeholder="Required"
                          validation="required"
                          input-class="form-control"
                          value="1"
                        />
                      </div>
                      <div class="col-4 pt-3"  v-if="settingCalculateTotals">
                        <FormulateInput
                          type="number"
                          v-if="settingCalculateTotals"
                          @input="setQuoteItemTotal(index)"
                          name="ItemValue"
                          label="Item Rate"
                          placeholder="Required"
                          validation="required"
                          input-class="form-control"
                          value="170"
                        />
                      </div>
                      <div class="col-4 pt-3">
                        <FormulateInput
                          type="text"
                          @input="setQuoteItemTotal(index)"
                          name="TotalValue"
                          label="Quote Item Value"
                          validation-name="Quote Item Value"
                          placeholder="Required"
                          help="When auto-calculate is off, you can enter numbers and text."
                          validation="required"
                          input-class="form-control"
                        />
                      </div>
                    </div>
                    </b-collapse>
                  </FormulateInput>
                </b-collapse>
              </div>
              </div>
            </div>
            <div class="bg-white p-3 rounded shadow-sm mt-5">             
            <div class="row">
              <div class="col">
                <h4 class="pt-2 mb-4 font-weight-bold">
                  Milestones
                  <b-button
                    variant="outline-secondary"
                    v-b-toggle.collapse-milestones
                    class="btn-sm float-right"
                    ><span class="when-open">Hide All</span
                    ><span class="when-closed">Show All</span></b-button
                  >
                </h4>
                <b-collapse visible id="collapse-milestones">
                  <FormulateInput
                    type="group"
                    name="Milestones"
                    v-model="Milestones"
                    :repeatable="true"
                    #default="{ index }"
                    remove-position="after"
                    add-label="Add Milestone"
                    validation="required"
                    label="Milestones"
                  >
                    <div class="pb-3" v-b-toggle="'collapse-milestoneItem-' + index + '-trigger'" v-if="formValues.Milestones[index]">
                        <div class="font-weight-bold d-inline-block" v-if="formValues.Milestones[index].MilestoneName" v-html="formValues.Milestones[index].MilestoneName"></div>
                        <div class="font-weight-bold d-inline-block" v-else>New Milestone Item</div>
                        <b-icon font-scale="2" class="when-closed float-right" icon="arrows-angle-expand" variant="dark"></b-icon>
                        <b-icon font-scale="2" class="when-open float-right" icon="arrows-collapse" variant="dark"></b-icon>
                    </div>                  
                    <b-collapse :id="'collapse-milestoneItem-' + index + '-trigger'">                   
                    <div class="row milestone-item">
                      <div class="col-12 mt-3 pt-2">
                        <FormulateInput
                          name="MilestoneName"
                          validation="required"
                          validation-name="Milestone Name"
                          placeholder="Required"
                          label="Milestone Name"
                          input-class="form-control"
                        />
                      </div>
                      <div class="col-12 pt-3">
                        <FormulateInput
                          type="textarea"
                          name="Description"
                          label="Description"
                          placeholder="Required"
                          validation="required"
                          input-class="form-control editor"
                        />
                      </div>
                      <div class="col-12 pt-3">
                        <FormulateInput
                          type="text"
                          name="Timeframe"
                          label="Timeframe"
                          placeholder="Required"
                          input-class="form-control"
                          validation="required"
                        />
                      </div>
                    </div>
                    </b-collapse>
                  </FormulateInput>
                </b-collapse>
              </div>
            </div>
            </div>
            <div class="bg-white p-3 rounded shadow-sm mt-5">
            <div class="row">
              <div class="col">
                <h4 class="pt-2 mb-4 font-weight-bold">
                  <span>Additional Pages </span>
                  <div
                    class="d-inline"
                    v-b-tooltip.hover
                    placement="auto"
                    title="Tip: This is for creating additional pages that have unique content. e.g to explain future development. These pages are added at the end of the document before the generic quote information."
                  >
                    <b-icon
                      class="ml-1"
                      icon="question-circle"
                      variant="secondary"
                    ></b-icon>
                  </div>
                  <b-button
                    variant="outline-secondary"
                    v-b-toggle.collapse-additionalPages
                    class="btn-sm float-right"
                    ><span class="when-open">Hide all</span
                    ><span class="when-closed">Show all</span></b-button
                  >
                </h4>
                <b-collapse visible id="collapse-additionalPages">
                  <FormulateInput
                    type="group"
                    remove-position="after"
                    name="AdditionalPages"
                    #default="{ index }"
                    v-model="AdditionalPages"
                    :repeatable="true"
                    add-label="Add Page"
                  >
                    <div class="pb-3" v-b-toggle="'collapse-AdditionalPages-' + index + '-trigger'" v-if="formValues.AdditionalPages[index]">
                        <div class="font-weight-bold d-inline-block" v-if="formValues.AdditionalPages[index].Heading" v-html="formValues.AdditionalPages[index].Heading"></div>
                        <div class="font-weight-bold d-inline-block" v-else>New Additional page</div>
                        <b-icon font-scale="2" class="when-closed float-right" icon="arrows-angle-expand" variant="dark"></b-icon>
                        <b-icon font-scale="2" class="when-open float-right" icon="arrows-collapse" variant="dark"></b-icon>
                    </div>                  
                    <b-collapse :id="'collapse-AdditionalPages-' + index + '-trigger'">                   
                    <div class="row AdditionalPages-item">
                      <div class="col-12 mt-3 pt-2">
                        <FormulateInput
                          name="Heading"
                          validation="required"
                          placeholder="Required"
                          label="Heading"
                          input-class="form-control"
                        />
                      </div>
                      <div class="col-12 mt-3 pt-2">
                        <FormulateInput
                          type="textarea"
                          name="Description"
                          validation="required"
                          placeholder="Required"
                          label="Description"
                          input-class="form-control editor"
                        />
                      </div>
                    </div>
                    </b-collapse>
                  </FormulateInput>
                </b-collapse>
              </div>
            </div>
            </div>
            <div class="bg-white p-3 rounded shadow-sm mt-5">
            <div class="row">
              <div class="col-12">
                <FormulateInput
                  type="text"
                  name="MilestoneEstimate"
                  validation-name="Milestone Estimate"
                  label="Estimated Total Time"
                  placeholder="Required - eg 10.5 Weeks"
                  validation="required"
                  input-class="form-control"
                />
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-12">
                <FormulateInput
                  type="number"
                  name="Total"
                  v-model="Total"
                  label="Total (Exc GST)"
                  help="Enter without $"
                  placeholder="Required"
                  validation="required"
                  input-class="form-control"
                />
              </div>
            </div>
            </div>
            <FormulateInput
              type="submit"
              input-class="btn btn-primary btn-lg btn-block d-lg-none bg-gradient"
              :label="contextText.action + ' Quote'"
              :disabled="hasErrors"
            />
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="success"
              class="mt-4"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
            >
              {{ formSubmitMsg }}
            </b-alert>
          </div>
        </div>
      </FormulateForm>
    </b-container>
    <b-modal id="bv-modal-createClient" size="lg"  hide-footer>
      <template #modal-title> Create Client </template>
      <div class="list-group mb-3 text-left border p-3 font-interface">
        <FormulateForm
          v-model="formValuesClient"
          @submit="submitHandlerClient"
          #default="{ hasErrors }"
        >
          <div class="mb-3">
            <FormulateInput
              type="text"
              :value="formValues.ClientAutocomplete"
              name="Name"
              label="Name"
              validation="required"
              input-class="form-control"
              placeholder="Required"
            />
          </div>
          <div class="mb-3">
            <FormulateInput
              type="email"
              name="Email"
              label="Email"
              input-class="form-control"
            />
          </div>
          <div class="mb-3">
            <FormulateInput
              type="text"
              name="Phone"
              label="Phone"
              input-class="form-control"
            />
          </div>
          <div class="mb-3">
            <FormulateInput
              type="textarea"
              name="Address"
              label="Address"
              input-class="form-control"
            />
            <FormulateInput
              type="submit"
              input-class="btn btn-primary btn-sm btn-block mt-3 bg-gradient"
              label="Create Client"
              :disabled="hasErrors"
            />
          </div>
        </FormulateForm>
      </div>
      <b-button class="mt-3" block @click="hideModalcreateClient"
        >Close</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import JQuery from "jquery";
import axios from "axios";

window.$ = JQuery;

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

export default {
  name: "QuoteNew",

  data() {
    return {
      StatusOptions: {
        draft: "Draft",
        review: "Review",
        published: "Published",
        sent: "Sent",
        accepted: "Accepted",
        declined: "Declined",
      },
      invalidFields: '',
      loading: false,
      formValuesClient: [],
      FormDataJson: "",
      quoteItems: "",
      StaffmemberOptions: "",
      ClientOptions: [],
      clients: [],
      Client: "",
      client: "",
      ClientAutocomplete: "",
      clientName: "",
      clientEmail: "",
      clientPhone: "",
      formPost: "",
      formValuesClientPost: "",
      webmadstaffs: [],
      QuoteItem: [],
      Milestones: [],
      AdditionalPages: [],
      Total: "",
      edit: false,
      duplicate: false,
      settingCalculateTotals: false,
      contextText: {
        type: "New",
        action: "Create",
        heading: "Create New Quote",
      },
      dismissSecs: 3,
      dismissCountDown: 0,
      formSubmitMsg: "",
      Status: "draft",
      Summary: "",
      HeadingOptions: [
        {
          value: "Optional Extras",
          label: "Optional Extras",
        },
        {
          value: "Ongoing Services",
          label: "Ongoing Services",
        },
      ],
      formValues: {
        Date: moment(String(new Date())).format("YYYY-MM-DD"),
        Expiry: moment(String(new Date())).add(21, "d").format("YYYY-MM-DD"),
        Summary: ''
      },
    };
  },
  watch: {
    Milestones: function () {
      this.$nextTick(function () {
        this.renderEditors();
      });
    },
    QuoteItem: function () {
      this.$nextTick(function () {
        this.renderEditors();
      });
    },
    AdditionalPages: function () {
      this.$nextTick(function () {
        this.renderEditors();
      });
    }, 
    Summary: function () {
      this.$nextTick(function () {
        this.renderEditors();
      });
    },       
  },
  methods: {
    invalidMessage(fields) {
        var returnErrors = [];
        for (var key in fields) {
        if (fields.hasOwnProperty(key)) {
                if(fields[key].label){
                  returnErrors.push(fields[key].label);
                }else{
                  returnErrors.push(fields[key].name);
                }
                
                console.log(key + " -> " + fields[key].label);
            }
        }
        this.invalidFields = returnErrors
    },
    async setQuoteItemTotal(index) {
      if (this.settingCalculateTotals === true) {
        let QuoteItem = this.formValues.QuoteItem[index];
        QuoteItem.TotalValue = (
          QuoteItem.Quantity * parseFloat(QuoteItem.ItemValue)
        ).toFixed(2);

        let QuoteItems = this.formValues.QuoteItem;
        let QuoteTotal = 0;
        Object.keys(QuoteItems).forEach(function (key) {
          if (
            QuoteItems[key].Heading != "Optional Extras" &&
            QuoteItems[key].Heading != "Ongoing Services"
          ) {
            QuoteTotal = QuoteTotal + parseFloat(QuoteItems[key].TotalValue);
          }
        });
        this.formValues.Total = QuoteTotal.toFixed(2);
      }
    },
    async updateQuoteHeadings() {
      const data = this;
      setTimeout(function () {
        const quotes = data.formValues.QuoteItem;
        let HeadingOptions = [
          {
            value: "Optional Extras",
            label: "Optional Extras",
          },
          {
            value: "Ongoing Services",
            label: "Ongoing Services",
          },
        ];
        Object.keys(quotes).forEach(function (key) {
          const index = HeadingOptions.findIndex(
            (item) => item.value == quotes[key].Heading
          );
          if (index < 0) {
            HeadingOptions.push({
              value: quotes[key].Heading,
              label: quotes[key].Heading,
            });
          }
        });
        data.HeadingOptions = HeadingOptions;
      }, 300);
    },
    hideModalcreateClient() {
      this.$root.$emit("bv::hide::modal", "bv-modal-createClient", "#btnShow");
    },
    myValidateClient(context, ...args) {
      if (!this.clients.data) {
        return false;
      }

      const index = this.clients.data.findIndex(
        (item) => item.Name == this.formValues.ClientAutocomplete
      );
      if (index < 1 || isNaN(this.clients.data[index].id)) {
        this.formValues.Client = "";
        this.clientName = "No Client Selected...";
        this.clientEmail = "";
        this.clientPhone = "";
        return false;
      }
      this.clientName = this.clients.data[index].Name;
      this.clientEmail = this.clients.data[index].Email;
      this.clientPhone = this.clients.data[index].Phone;
      this.formValues.Client = this.clients.data[index].id;

      return true;
    },
    myValidateClientMessage({ value, formValues, args }) {
      console.log(formValues);
      if (isNaN(this.Client)) {
        return `This client doesn't exist, please create.`;
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    //set context create or edit
    setContext($type) {
      if ($type == "edit") {
        this.edit = true;
        this.contextText.type = "Edit";
        this.contextText.action = "Update";
        this.contextText.heading = "Edit Quote -";
      } else if ($type == "duplicate") {
        this.duplicate = true;
        this.contextText.type = "Duplicate";
        this.contextText.action = "Create";
        this.contextText.heading = "Duplicate Quote - ";
      }
    },

    //Quote form submission handler
    async submitHandler(data) {
      if (this.edit === true) {
        axios
          .put("/api/quotes/" + data.id, data, {
            headers: {
              Authorization: `Bearer ${this.$store.state.userJWT}`,
            },
          })
          .then((response) => {
            this.formPost = response;
            this.$router.push({
              name: "quotes",
              params: {
                saveSuccess: true,
                message: "Quote Successfully Updated",
              },
            });
          })
          .catch((error) => {
            console.log(error);
            this.formSubmitMsg = "Something went wrong...";
            this.showAlert();
            this.formPost = error.response.data;
            this.$root.handleError(error.response);
          });
      } else {
        axios
          .post("/api/quotes/", data, {
            headers: {
              Authorization: `Bearer ${this.$store.state.userJWT}`,
            },
          })
          .then((response) => {
            const quoteId = response.data.id;
            const hashId = this.$root.encrpytQuoteId(response.data.id);

            data = {
              quoteId: quoteId,
              hashId: hashId,
            };
            axios
              .post("/api/quotespublics/", data, {
                headers: {
                  Authorization: `Bearer ${this.$store.state.userJWT}`,
                },
              })
              .then((response) => {
                this.$router.push({
                  name: "quotes",
                  params: {
                    saveSuccess: true,
                    message: "Quote Successfully Created",
                  },
                });
              })
              .catch((error) => {
                console.log(error);
                this.formPost = error.response.data;
                this.$root.handleError(error.response);
              });
          })
          .catch((error) => {
            console.log(error);
            this.formPost = error.response.data;
            this.$root.handleError(error.response);
          });
      }
    },

    //Create client form submission handler
    async submitHandlerClient(data) {
      axios
        .post("/api/clients/", data, {
          headers: {
            Authorization: `Bearer ${this.$store.state.userJWT}`,
          },
        })
        .then((response) => {
          this.addClientOption(response.data);
          this.formValuesClientPost = response;
          this.formValuesClient = [];
          this.hideModalcreateClient();
        })
        .catch((error) => {
          console.log(error);
          this.formValuesClientPost = error.response.data;
          this.$root.handleError(error.response);
        });
    },

    //Set the client select options
    async addClientOption(data) {
      this.ClientOptions.push({
        value: data.id,
        label: data.Name,
      });
      this.clients.data.push(data);
      this.formValues.ClientAutocomplete = data.Name;
      this.Client = data.id;
    },

    //render tinymcs on textareas
    async renderEditors() {
      window.tinymce.init({
        menubar: false,
        statusbar: false,
        plugins: "lists, fullscreen",
        toolbar:
          "undo redo | bold italic underline removeformat | bullist numlist | fullscreen",
        selector: ".editor",
        contextmenu: false,
        block_formats: "Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3",
        init_instance_callback: function (editor) {
          editor.on("Change", function () {
            let el = document.getElementById(this.id);
            el.value = window.tinymce.get(this.id).getContent();
            el.dispatchEvent(new Event("input"));
          });
        },
      });
    },
  },

  async mounted() {
    this.$root.requiresUserAuth();

    

    //show alert after submission
    if (this.$route.params.QuoteUpdated) {
      this.showAlert();
    }

    //populate fields for edit view
    if (this.$route.params.id || this.$route.params.duplicateQuoteId) {
      this.loading = true;
      let id = "";

      if (this.$route.params.id) {
        id = this.$route.params.id;
        this.setContext("edit");
      } else {
        this.setContext("duplicate");
        id = this.$route.params.duplicateQuoteId;
      }

      axios
        .get("/api/quotes/" + id, {
          headers: {
            Authorization: `Bearer ${this.$store.state.userJWT}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          const formData = response.data;

          if (this.$route.params.duplicateQuoteId) {
            console.log("here");
            formData.Date = moment(String(new Date())).format("YYYY-MM-DD");
            formData.Expiry = moment(String(new Date()))
              .add(21, "d")
              .format("YYYY-MM-DD");
            formData.Status = "draft";
          }
          if (this.$route.params.id) {
            if (formData.Status == "published") {
              this.StatusOptions = {
                published: "Published",
                review: "Review",
                sent: "Sent",
                accepted: "Accepted",
                declined: "Declined",
              };
            } else if (formData.Status == "sent") {
              this.StatusOptions = {
                sent: "Sent",
                accepted: "Accepted",
                declined: "Declined",
              };
            } else if (
              formData.Status == "accepted" ||
              formData.Status == "declined"
            ) {
              this.StatusOptions = {
                accepted: "Accepted",
                declined: "Declined",
              };
            }
          }

          formData.ClientAutocomplete = formData.Client.Name;
          formData.Client = formData.Client.id;

          const webmadstaffs = formData.webmadstaffs;

          formData.webmadstaffs = {};

          formData.webmadstaffs = webmadstaffs.map((staffmember) => {
            return staffmember.id;
          });

          this.formValues = formData;
          this.updateQuoteHeadings();
          this.myValidateClient();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$root.handleError(error.response);
        });
    }


    //get webmadstaffs
    axios
      .get("/api/webmad-staffs", {
        headers: {
          Authorization: `Bearer ${this.$store.state.userJWT}`,
        },
      })
      .then((response) => {
        this.StaffmemberOptions = response.data.map((item) => {
          return {
            value: item.id,
            label: item.Name,
          };
        });
      })
      .catch((error) => {
        console.log(error);
        this.error = error;
        this.$root.handleError(error.response);
      });

    //get clients
    axios
      .get("/api/clients", {
        headers: {
          Authorization: `Bearer ${this.$store.state.userJWT}`,
        },
      })
      .then((response) => {
        this.clients = response;
        this.ClientOptions = response.data.map((item) => {
          return {
            value: item.id,
            label: item.Name,
          };
        });
        this.myValidateClient();
      })
      .catch((error) => {
        console.log(error);
        this.error = error;
        this.$root.handleError(error.response);
      });

  //this.renderEditors();
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
